<template>
    <div>
        <div v-if="marcacao && marcacao.doc_pre_atends && marcacao.doc_pre_atends.length" class="card mb-3">
            <div v-for="(doc_pre, idx) in marcacao.doc_pre_atends" :key="idx"> 
                <div class="card-header d-flex justify-content-between">
                    <a class="card-link" data-toggle="collapse" :href="'#collapsePreAtendimento' + idx" role="button">
                        {{ doc_pre.st_titulo }}
                    </a>
                    <a href="#" @click.prevent="callback_preenchimento(doc_pre.js_conteudo, doc_pre.st_titulo)" v-if="callback_preenchimento" title="Preencher formulários abaixo">
                        <i class="fa-solid fa-arrow-down"></i>
                    </a>
                    <div class="text-right d-flex">
                        <span v-if="doc_pre.created_at">
                            <small class="text-muted" v-if="doc_pre.fl_preenchido_pelo_paciente">Preenchido pelo Paciente</small>
                            <small class="text-muted" v-else-if="doc_pre.usuario">{{ doc_pre.usuario.st_login }}</small>

                            <span class="small ml-3">
                                {{ $util.getFormatDate(doc_pre.created_at.substr(0,10)) }}
                                {{ doc_pre.created_at.substr(11,5) }}
                            </span>
                        </span>

                        <span v-if="pode_assinar(doc_pre)">
                            <span v-if="doc_pre.doc_certificado && doc_pre.doc_certificado.arquivo">
                                <a :href="doc_pre.doc_certificado.arquivo.temporary_url" class="ml-3" target="_blank" title="Documento assinado.">
                                    <i class="fas fa-file-contract fa-fw"></i>
                                </a>

                                <a href="#" class="alert-link mr-1 ml-2" @click.prevent="cancelar_ass(doc_pre)" title="Cancelar Assinatura">
                                    <i class="fa fa-times-circle" aria-hidden="true"></i>
                                </a>                                
                            </span>

                            <a href="#" class="ml-3" @click.prevent="assinar(doc_pre)" title="Assinar Documento" v-else>
                                <i class="fas fa-signature fa-fw"></i>
                            </a>
                        </span>

                        <span class="ml-2" v-else-if="doc_pre.doc_certificado">
                            <a :href="doc_pre.doc_certificado.arquivo.temporary_url" class="ml-3" target="_blank" title="Documento assinado.">
                                <i class="fas fa-file-contract fa-fw"></i>
                            </a>
                        </span>
                    </div>
                </div>
                <div class="collapse" :class="aberto ? 'show' : ''" :id="'collapsePreAtendimento' + idx">
                    <div class="card-body">
                        <div>
                            <div class="d-flex justify-content-between" v-if="false">
                                <h3>{{ doc_pre.st_titulo }}</h3>
                                <span v-if="doc_pre.created_at" class="text-right">
                                    {{ $util.getFormatDate(doc_pre.created_at.substr(0,10)) }}
                                    {{ doc_pre.created_at.substr(11,5) }}<br>
                                    <small class="text-muted" v-if="doc_pre.fl_preenchido_pelo_paciente">Preenchido pelo Paciente</small>
                                </span>
                            </div>
                            <formulario 
                                :modelo_prontuario="doc_pre.modelo_prontuario"
                                v-model="doc_pre.js_conteudo" 
                                mode="view" />
                        </div>
                        <button type="button" class="btn btn-sm btn-outline-primary" @click="editar_pre(doc_pre)">
                            <i class="fas fa-edit mr-2"></i>Editar
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <assinar-p-e-p ref="assinador" />
    </div>
</template>

<script>
import Formulario from './Formulario.vue';
import AssinarPEP from './AssinarPEP.vue';

export default {
    props: ['marcacao', 'aberto', 'callback_preenchimento', 'tem_ass', 'pode_editar'],

    components: { 
        Formulario,
        AssinarPEP, 
    },

    methods: { 
        editar_pre (doc_pre) { 
            this.$emit('editar', doc_pre);
        },

        cancelar_ass(doc) { 

            if ( !confirm('Confirma cancelar a assinatura do documento?') ) { 
                return;
            }

            this.$util.atualizar(this, { 
                service: 'documentos_pre_atendimento',
                func: 'cancelar_ass',
                dados: { 
                    id_documento_pre_atendimento: doc.id_documento_pre_atendimento, 
                },
                callback: () => { 
                    this.$emit('refresh');
                },
                toast: true, 
            });

        },

        pode_assinar(doc) { 
            if ( !this.tem_ass ) { 
                return false;
            }

            let usuario = this.$store.state.user;

            if ( usuario && usuario.medico && usuario.id_usuario == doc.id_usuario ) { 
                return true; 
            }

            return false;
        },

        assinar (doc) { 
            console.log(doc);

            this.$refs.assinador.solicitar(
                -1,
                'documentoPreAtendimento',
                doc.id_documento_pre_atendimento,
                () => { 
                    this.$emit('refresh');
                }
            );
        },
    }
}
</script>